import React from 'react';
import { useContext } from 'react';
import { cartContext } from '../Context/CartContext';
import { useCartDrawer } from '../Context/CartDrawerContext';
import { useTranslation } from 'react-i18next';
import { Badge } from 'react-bootstrap';
import { BsCart4 } from "react-icons/bs";

const CartWidget = () => {
  const { cartLocal } = useContext(cartContext);
  const { abrirCarrito } = useCartDrawer();
  const [t] = useTranslation('global');
  const totalUnidades = !cartLocal ? 0 : cartLocal.reduce((total, producto) => total + producto.contador, 0);

  return (
    <div style={{ display: 'flex', alignItems: 'center', padding: '10px', margin: '0 15px' }}>
      {totalUnidades > 0 && (
        <button
          type="button"
          onClick={abrirCarrito}
          className='d-flex align-items-center'
          aria-label={t('carritoLateral.abrir')}
          style={{ background: 'none', border: 0, padding: 0, cursor: 'pointer' }}
        >
          <BsCart4 size={24} style={{ color: 'white', marginRight: '10px' }} />
          <Badge pill bg="danger" style={{ color: 'white', fontSize: '12px', lineHeight: '1', transform: 'translateY(-10px) translateX(-8px)', }}>
            {totalUnidades}
          </Badge>
        </button>
      )}
    </div>
  );
};

export default CartWidget;
